export const systemVariables = {
    apiUrl: 'https://equiup-api.13bit.dev/api/v2',
    appVersion: '1.0.0',
};
